import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import CodeEditor from '@uiw/react-textarea-code-editor';
import yaml from "js-yaml";
import { setWWNDS } from 'interactive';
import { MathJaxContext } from "better-react-mathjax";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import { IdProvider } from "react-use-id-hook";
import download from 'downloadjs';
import ContentEditable from 'react-contenteditable';
import sanitizeHtml from "sanitize-html";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Interactive, deepMap, hydrate } from './DataStructures';
import InteractiveRenderer from './InteractiveRenderer';
import ComponentToolbox from './ComponentToolbox';
import ErrorBoundary from './ErrorBoundary';
import InteractiveEditor from './InteractiveEditor';
import FormControl from 'react-bootstrap/FormControl';
import DataForm from './DataForm';
import { TabContextProvider } from './TabContext';
import PanelList from './PanelList';
import ComponentList from './ComponentList';
import PipelineButton from "./controls/PipelineButton/PipelineButton";
import { buildHierarchy, getChildComponents } from "./util";
import AutoQAButton from "./controls/AutoQAButton/AutoQAButton";
import QAReport from "./controls/QAReport/QAReport";
import './App.css';

// Set to true to debug this file
const DEBUG = false;
const reloadAfterSave = false;
export default class InteractiveEditorInterface extends React.Component {
  constructor(props) {
    var _props$data$title, _props$data;
    super(props);
    //let hydrated = deepMap(JSON.parse(JSON.stringify(interactive)), hydrate)
    this.state = {
      selectedPage: 0,
      selectedComponent: undefined,
      lastRenderedAt: 0,
      dropGeneration: 0,
      interactiveTitle: (_props$data$title = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.title) !== null && _props$data$title !== void 0 ? _props$data$title : "Interactive Builder",
      isSaving: false,
      searched: "",
      inspectorActiveTab: 0,
      tabListKey: 0,
      hierarchy: {},
      report: [],
      showReport: false
    };
    this.editorRef = /*#__PURE__*/React.createRef();
    this.editorColumnRef = /*#__PURE__*/React.createRef();
    this.toolboxRef = /*#__PURE__*/React.createRef();
    this.compileIteration = 0;
    this.onComponentListClick = this.onComponentListClick.bind(this);
    this.onComponentListDrop = this.onComponentListDrop.bind(this);
    this.onComponentListDrag = this.onComponentListDrag.bind(this);
    this.clearInspector = this.clearInspector.bind(this);
    this.openInspector = this.openInspector.bind(this);
    this.onDropLastIndexChanged = this.onDropLastIndexChanged.bind(this);
    this.decrementActiveTab = this.decrementActiveTab.bind(this);
    this.refreshTabList = this.refreshTabList.bind(this);
    this.bundleInteractive = this.bundleInteractive.bind(this);
    this.bundleInteractiveYaml = this.bundleInteractiveYaml.bind(this);
    this.onChanged = this.onChanged.bind(this);
    this.focusEditor = this.focusEditor.bind(this);
    this.setReport = this.setReport.bind(this);
    this.closeReport = this.closeReport.bind(this);
  }
  setReport(report) {
    this.setState({
      report: report,
      showReport: true
    });
  }
  closeReport() {
    this.setState({
      showReport: false
    });
  }
  componentDidUpdate(prevprops, prevstate) {
    if (prevprops.preview != this.props.preview) {
      DEBUG && console.log("preview bump");
      ++this.compileIteration;
      this.forceUpdate();
    }
    if (prevstate.inspectorRoot !== this.state.inspectorRoot) {
      this.setState({
        screenMode: this.props.preview ? "preview" : this.state.inspectorRoot ? "inspector" : "editor"
      });
    }
    if (this.state.inspectorPath && prevstate.inspectorPath !== this.state.inspectorPath) {
      this.setState({
        hierarchy: buildHierarchy(this.state.inspectorRoot[this.state.inspectorPath[0]], getChildComponents)
      });
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.debounceUpdate);
    window.clearInterval(this.autosaveId);
  }
  bundleInteractive() {
    let body = JSON.stringify({
      ...this.props.data,
      panels: this.props.data.panels.map(JSON.stringify)
    });
    let fname = this.props.data.title;
    fname = fname.toLowerCase();
    fname = fname.replaceAll(/\W/g, "-");
    let blob = new TextEncoder().encode(body);
    return {
      fname,
      blob
    };
  }
  bundleInteractiveYaml() {
    let body = yaml.dump({
      title: this.props.data.title,
      interactive: {
        ...this.props.data,
        panels: deepMap(this.props.data.panels, item => {
          if (item.toJSON) {
            return item.toJSON();
          }
          return item;
        })
      }
    });
    let fname = this.props.data.title;
    fname = fname.toLowerCase();
    fname = fname.replaceAll(/\W/g, "-");
    let blob = new TextEncoder().encode(body);
    return {
      fname,
      blob
    };
  }
  downloadJSON() {
    if (true) {
      const {
        fname,
        blob
      } = this.bundleInteractive();
      DEBUG && console.log("download body:", blob);
      download(blob, `${fname}-v${this.props.data.revision}.${this.props.data.revisionMinor}.json`, 'application/json;charset=utf-8');
    }
    if (true) {
      const {
        fname,
        blob
      } = this.bundleInteractiveYaml();
      DEBUG && console.log("download body:", blob);
      download(blob, `${fname}-v${this.props.data.revision}.${this.props.data.revisionMinor}.yml`, 'application/x-yaml;charset=utf-8');
    }
  }
  onComponentListClick(key) {
    this.setState({
      selectedComponent: key
    });
  }
  onComponentListDrop(index, key, didDrop) {
    var _this$editorRef$curre;
    DEBUG && console.log("dragdrop onDrop", index, key, didDrop);
    let cloned = JSON.parse(JSON.stringify(ComponentToolbox[key]));
    let hydrated = deepMap(cloned, hydrate);
    (_this$editorRef$curre = this.editorRef.current) === null || _this$editorRef$curre === void 0 ? void 0 : _this$editorRef$curre.onComponentListDrop(index, key, didDrop, hydrated);
    this.setState({
      dropGeneration: this.state.dropGeneration + 1
    });
  }
  onComponentListDrag(isDragging) {
    if (typeof isDragging !== "boolean") return;
    DEBUG && console.log("dragdrop onDrag", isDragging);
    if (this.toolboxRef.current) {
      if (isDragging) {
        //this.toolboxRef.current.style.overflowY = "hidden"
        this.setState({
          toolboxScrollDisabled: true,
          toolboxScroll: this.toolboxRef.current.scrollTop
        });
      } else if (this.state.toolboxScrollDisabled) {
        let scroll = this.state.toolboxScroll;
        if (scroll !== undefined) {
          this.toolboxRef.current.scrollTop = scroll;
        }
        window.setTimeout(() => {
          if (scroll !== undefined) {
            this.toolboxRef.current.scrollTop = scroll;
          }
        }, 1);
        this.setState({
          toolboxScrollDisabled: false,
          toolboxScroll: undefined
        });
      }
    }
  }
  componentDidMount() {}
  clearInspector() {
    this.setState({
      inspectorRoot: undefined,
      inspectorPath: undefined
    });
  }
  openInspector(root, path) {
    this.setState({
      inspectorRoot: root,
      inspectorPath: path
    });
  }
  onDropLastIndexChanged(lastIndex) {
    this.setState({
      panelLastIndex: lastIndex,
      dropGeneration: this.state.dropGeneration + 1
    });
  }
  decrementActiveTab() {
    this.setState({
      inspectorActiveTab: this.state.inspectorActiveTab !== 0 ? this.state.inspectorActiveTab - 1 : 0
    });
  }
  refreshTabList() {
    this.setState({
      tabListKey: this.state.tabListKey + 1
    });
  }
  onChanged() {
    DEBUG && console.log("InteractiveEditorInterface onChanged");
    if (this.props.onChanged) {
      this.props.onChanged();
    }
  }
  focusEditor() {
    console.log("focusEditor");
    this.editorColumnRef.current.focus();
  }
  render() {
    var _this$props$data, _this$props$data2, _this$props$data3, _this$props$data4, _this$props$data5;
    const screenMode = this.props.preview ? "preview" : this.state.inspectorRoot ? "inspector" : "editor";
    if ((_this$props$data = this.props.data) !== null && _this$props$data !== void 0 && _this$props$data.title && this.state.interactiveTitle === "Interactive Builder") {
      this.setState({
        interactiveTitle: this.props.data.title
      });
    }
    return /*#__PURE__*/React.createElement(MathJaxContext, {
      version: 3
    }, /*#__PURE__*/React.createElement(DndProvider, {
      backend: HTML5Backend
    }, /*#__PURE__*/React.createElement(IdProvider, null, /*#__PURE__*/React.createElement(Row, {
      className: "app " + (screenMode + "-mode")
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement(Row, {
      className: "title-row"
    }, /*#__PURE__*/React.createElement(Col, null, !this.props.noTitle && /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(ContentEditable, {
      style: {
        display: 'inline',
        whiteSpace: 'pre'
      },
      html: this.state.interactiveTitle,
      onChange: e => {
        let title = sanitizeHtml(`$${e.target.value}$`, {
          allowedTags: []
        });
        console.log("THIS TITLE:", title, "value", e.target.value, "data", this.props.data);
        title = title.substr(1, title.length - 2);
        if (this.props.data) {
          // eslint-disable-next-line react/no-direct-mutation-state
          this.props.data.title = title;
        }
        this.setState({
          interactiveTitle: title
        });
      }
    }), this.props.data && this.props.data.revision !== undefined && /*#__PURE__*/React.createElement("span", {
      className: "revision"
    }, ' ', "v", this.props.data.revision, ".", this.props.data.revisionMinor))), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, /*#__PURE__*/React.createElement(ButtonToolbar, null, /*#__PURE__*/React.createElement(PipelineButton, {
      repoId: this.props.productId
    }), /*#__PURE__*/React.createElement(AutoQAButton, {
      panels: (_this$props$data2 = this.props.data) === null || _this$props$data2 === void 0 ? void 0 : _this$props$data2.panels,
      setReport: this.setReport
    }), /*#__PURE__*/React.createElement(ButtonGroup, {
      className: "mr-2 my-1"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: () => {
        this.setState({
          mobile: !this.state.mobile
        });
      }
    }, this.state.mobile ? "Desktop Layout" : "Mobile Layout")), this.props.showSaveButton && /*#__PURE__*/React.createElement(ButtonGroup, {
      className: "mr-2 my-1"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      disabled: this.props.isSaving || !this.props.data,
      onClick: this.props.saveInteractive
    }, this.props.isSaving ? "Saving..." : "Save")), /*#__PURE__*/React.createElement(ButtonGroup, {
      className: "mr-2 my-1"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: () => {
        this.downloadJSON();
      }
    }, "Export")), /*#__PURE__*/React.createElement(ButtonGroup, {
      className: "mr-2 my-1"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: () => {
        this.setState({
          settingsOpen: true
        });
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-gear-fill"
    })))))), /*#__PURE__*/React.createElement(QAReport, {
      panel: (_this$props$data3 = this.props.data) === null || _this$props$data3 === void 0 ? void 0 : _this$props$data3.panels[this.state.selectedPage],
      report: this.state.report,
      showReport: this.state.showReport,
      closeReport: this.closeReport
    }), /*#__PURE__*/React.createElement(Modal, {
      show: this.state.settingsOpen,
      onHide: () => {
        this.setState({
          settingsOpen: false
        });
      }
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }, "Settings"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Use WWNDS styling"), /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      checked: (_this$props$data4 = this.props.data) === null || _this$props$data4 === void 0 ? void 0 : _this$props$data4.wwnds,
      onChange: e => {
        this.props.data.wwnds = e.target.checked;
        setWWNDS(e.target.checked);
        this.forceUpdate();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Custom CSS"), /*#__PURE__*/React.createElement(CodeEditor, {
      value: (_this$props$data5 = this.props.data) === null || _this$props$data5 === void 0 ? void 0 : _this$props$data5.css,
      language: "css",
      onChange: e => {
        this.props.data.css = e.target.value;
        this.onChanged();
      },
      className: "richtext"
    }))))), this.state.saveError && /*#__PURE__*/React.createElement("div", {
      className: "error text-right"
    }, this.state.saveError, ' ', /*#__PURE__*/React.createElement("i", {
      className: "bi bi-x-lg",
      title: "Dismiss",
      onClick: () => {
        this.setState({
          saveError: undefined
        });
      }
    })), /*#__PURE__*/React.createElement(Row, {
      className: "pages-row"
    }, ["editor", "inspector", "preview"].includes(screenMode) && /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "panels-col sideways panel-scroll"
    }, /*#__PURE__*/React.createElement(ErrorBoundary, null, this.props.data && /*#__PURE__*/React.createElement(PanelList, {
      key: this.compileIteration,
      data: this.props.data,
      onChange: this.onChanged,
      selectedPage: this.state.selectedPage,
      onConfigClicked: i => {
        var _this$editorRef$curre2;
        (_this$editorRef$curre2 = this.editorRef.current) === null || _this$editorRef$curre2 === void 0 ? void 0 : _this$editorRef$curre2.openPageConfig(i);
      },
      onClick: i => {
        DEBUG && console.log("Click", i);
        if (i < this.props.data.panels.length) {
          var _this$editorRef$curre3;
          DEBUG && console.log("click success");
          this.setState({
            selectedPage: i,
            dropGeneration: this.state.dropGeneration + 1
          });
          (_this$editorRef$curre3 = this.editorRef.current) === null || _this$editorRef$curre3 === void 0 ? void 0 : _this$editorRef$curre3.changePage(i);
        }
      },
      onDrop: (index, id, didDrop) => {
        this.setState({
          dropGeneration: this.state.dropGeneration + 1
        });
      }
    }))))), /*#__PURE__*/React.createElement(Row, {
      className: "body-row"
    }, screenMode === "editor" && /*#__PURE__*/React.createElement(Col, {
      xs: 2,
      ref: this.toolboxRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "components-col",
      style: {
        overflow: "hidden"
      }
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-center"
    }, "Toolbox"), /*#__PURE__*/React.createElement(Form, {
      className: "d-flex",
      style: {
        padding: "5px"
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      type: "search",
      placeholder: "Search",
      "aria-label": "Search",
      onChange: e => this.setState({
        searched: e.target.value
      })
    })), /*#__PURE__*/React.createElement(ErrorBoundary, null, this.props.data && /*#__PURE__*/React.createElement(ComponentList, {
      dropGeneration: this.state.dropGeneration,
      selectedComponent: this.state.selectedComponent,
      panelLastIndex: this.state.panelLastIndex,
      onClick: this.onComponentListClick,
      onDrop: this.onComponentListDrop,
      onDrag: this.onComponentListDrag,
      search: this.state.searched,
      focusEditor: this.focusEditor
    })))), screenMode === "inspector" && /*#__PURE__*/React.createElement(Col, {
      xs: 2
    }, /*#__PURE__*/React.createElement("div", {
      className: "inspector-col"
    }, /*#__PURE__*/React.createElement(Nav, {
      key: this.state.tabListKey,
      variant: "pills",
      className: "flex-column"
    }, this.state.inspectorStateRef && Object.keys(this.state.inspectorStateRef).sort().map(i => {
      i = isNaN(Number(i)) ? i : Number(i);
      let v = this.state.inspectorStateRef[i];
      if (v !== undefined && v && v.replaceAll) {
        v = v.replaceAll(".", "   ");
      }
      return /*#__PURE__*/React.createElement(Nav.Link, {
        key: i,
        active: this.state.inspectorActiveTab === i,
        onClick: () => this.setState({
          inspectorActiveTab: i
        })
      }, v);
    })))), /*#__PURE__*/React.createElement(Col, {
      xs: {
        inspector: 10,
        editor: 10,
        preview: 12
      }[screenMode]
    }, /*#__PURE__*/React.createElement(Row, {
      className: "editor-row"
    }, ["inspector", "editor"].includes(screenMode) && /*#__PURE__*/React.createElement(Col, {
      xs: 5
    }, screenMode === "inspector" && /*#__PURE__*/React.createElement("div", {
      className: "inspector-col"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      style: {
        float: "right"
      },
      onClick: () => {
        this.clearInspector();
        this.forceUpdate();
      }
    }, "Close"), /*#__PURE__*/React.createElement("h4", {
      className: "text-center",
      style: {
        marginBottom: "25px"
      }
    }, "Inspector"), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(TabContextProvider, {
      noTabs: true,
      activeTab: this.state.inspectorActiveTab,
      onChange: t => this.setState({
        inspectorActiveTab: t
      }),
      onTabsChange: v => this.setState({
        inspectorStateRef: v
      })
    }, this.state.inspectorRoot && this.editorRef.current ? /*#__PURE__*/React.createElement(DataForm, {
      onChanged: this.onChanged,
      parent: this.state.inspectorRoot,
      path: this.state.inspectorPath,
      scopedDataParent: this.state.scopedDataParent,
      triggerStateUpdate: this.editorRef.current.triggerStateUpdate,
      openDataModal: this.editorRef.current.openDataModal,
      scopeToItem: this.editorRef.current.scopeToItem,
      decrementActiveTab: this.decrementActiveTab,
      refreshTabList: this.refreshTabList
    }) : null)), this.state.inspectorStateRef && parseInt(this.state.inspectorActiveTab) !== 0 && /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      style: {
        float: "left",
        marginTop: "10px"
      },
      disabled: reloadAfterSave && this.props.isSaving || !this.props.data,
      onClick: () => {
        let currentTabIndex = parseInt(this.state.inspectorActiveTab);
        if (currentTabIndex !== 0) {
          this.setState({
            inspectorActiveTab: String(currentTabIndex - 1)
          });
        }
      }
    }, "Back"), this.state.inspectorStateRef && parseInt(this.state.inspectorActiveTab) + 1 < Object.keys(this.state.inspectorStateRef).length && /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      style: {
        float: "right",
        marginTop: "10px"
      },
      disabled: reloadAfterSave && this.props.isSaving || !this.props.data,
      onClick: () => {
        let currentTabIndex = parseInt(this.state.inspectorActiveTab);
        if (currentTabIndex + 1 < Object.keys(this.state.inspectorStateRef).length) {
          this.setState({
            inspectorActiveTab: String(currentTabIndex + 1)
          });
        }
      }
    }, "Next"), /*#__PURE__*/React.createElement(Button, {
      variant: this.state.inspectorStateRef && "success",
      style: {
        float: "right",
        marginRight: "10px",
        marginTop: "10px"
      },
      disabled: reloadAfterSave && this.props.isSaving || !this.props.data,
      onClick: () => {
        this.props.saveInteractive();
      }
    }, this.props.isSaving ? "Saving..." : "Save"))), /*#__PURE__*/React.createElement(Col, {
      xs: {
        "preview": 12,
        "editor": 7,
        "inspector": 7
      }[screenMode]
    }, /*#__PURE__*/React.createElement("div", {
      class: "sr-only",
      "aria-hidden": "true",
      ref: this.editorColumnRef,
      tabindex: 0
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "45px"
      },
      className: "interactive-col" + (screenMode === "preview" ? " preview" : "") + (reloadAfterSave && this.props.isSaving ? " disabled" : "")
    }, ["editor", "inspector"].includes(screenMode) && /*#__PURE__*/React.createElement("h4", {
      className: "text-center"
    }, "Editor"), this.props.data && /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: this.state.mobile ? '256px' : '728px',
        margin: 'auto'
      }
    }, ["editor", "inspector"].includes(screenMode) && /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("style", null, this.props.data.css), /*#__PURE__*/React.createElement(InteractiveEditor, {
      onChanged: this.onChanged,
      rootPath: ["panels", this.state.selectedPage, "children"],
      rootPathName: "Page " + (this.state.selectedPage + 1),
      selectedComponent: this.state.selectedComponent,
      data: this.props.data,
      ref: this.editorRef,
      setAppState: (...args) => {
        console.log("setAppState", ...args);
        //this.setState(...args)
      },

      disabled: reloadAfterSave && this.props.isSaving,
      saveInteractive: this.props.saveInteractive,
      inspectorRoot: this.state.inspectorRoot,
      inspectorPath: this.state.inspectorPath,
      openInspector: this.openInspector,
      clearInspector: this.clearInspector,
      onDropLastIndexChanged: this.onDropLastIndexChanged,
      onUpdate: () => {
        ++this.compileIteration;
        DEBUG && console.log("onUpdate", this.compileIteration);
        window.clearTimeout(this.debounceUpdate);
        this.debounceUpdate = window.setTimeout(() => {
          DEBUG && console.log("debounced!", this.compileIteration);
          this.setState({
            lastRenderedAt: this.compileIteration
          });
        }, 1000);
        //this.forceUpdate()
      }
    })), screenMode === "preview" && /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("style", null, this.props.data.css), /*#__PURE__*/React.createElement("div", {
      onClickCapture: e => {
        /*
        try {
          if (e.target.closest(".reset-button")) {
            DEBUG && console.log("Caught reset button!")
            e.stopPropagation()
            e.preventDefault()
            this.setState({previewMode: false})
          }
        } catch (e) {
                }
        */
      }
    }, /*#__PURE__*/React.createElement(InteractiveRenderer, {
      key: this.compileIteration,
      storageKey: this.compileIteration,
      selectedComponent: this.state.selectedComponent,
      data: this.props.data,
      attributes: {
        page: this.state.selectedPage,
        onPageChange: p => {
          this.setState({
            selectedPage: p
          });
        }
      }
    })))), /*#__PURE__*/React.createElement("pre", null, this.props.data && false && JSON.stringify(this.props.data, null, 2))))))))))));
  }
}